import { IndividualScheduleRepository } from "@/repositories/individual-schedule.repository";
import { availabilityDaysOf, weeklyScheduleOf, type WeeklySchedule } from "@/models/individual-schedule.model";
import { uuid } from "@/interfaces";

export const scheduleApi = {
  async getSchedule(shell: uuid): Promise<WeeklySchedule> {
    const { days } = await IndividualScheduleRepository.mine(shell);
    return weeklyScheduleOf(days);
  },

  async saveSchedule(shell: uuid, schedule: WeeklySchedule): Promise<WeeklySchedule> {
    const { days } = await IndividualScheduleRepository.saveMine(shell, availabilityDaysOf(schedule));
    return weeklyScheduleOf(days);
  },
};
